
import * as React from "react"
import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <div className="relative w-full">
        <input
          type={type}
          className={cn(
            "flex h-10 w-full rounded-md px-3 py-2 text-base ring-offset-background",
            "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
            "bg-white/30 dark:bg-white/10 backdrop-blur-sm border border-accent/20",
            "focus-visible:outline-none focus-visible:border-accent/40 focus-visible:ring-0 focus-visible:ring-offset-0",
            "focus:outline-none focus:border-accent/40 focus:ring-0 focus:ring-offset-0",
            "transition-all duration-300 shadow-sm hover:shadow-md hover:border-accent/30",
            "placeholder:text-gray-400 hover:placeholder:text-gray-200",
            "disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
